// @flow
import CopyrightNotice from '@ta-interaktiv/react-copyright-notice'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import ShareButtons from '@ta-interaktiv/react-share-buttons'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import { VerticalSegment } from 'components/verticalSegment'
import React, { useContext } from 'react'
import './styles.scss'
import { LocaleContext } from '../../contexts/locale'

interface FooterProps {
  articleId: string
  publicationDate: number
}

export function Footer({ articleId, publicationDate }: FooterProps) {
  const locale = useContext(LocaleContext)
  let messages = require('./locales/' + locale + '.yml')

  return (
    <VerticalSegment className='relaxed infographic grey ta footer'>
      <div className='ui two column stackable  grid'>
        <div className='row credits'>
          <div className='column'>
            <table className='ui small basic definition infographic  table top aligned'>
              <tbody>
                <tr className={'top aligned'}>
                  <td>{messages.concept.title}</td>
                  <td>{messages.concept.credits}</td>
                </tr>
                <tr className={'top aligned'}>
                  <td>{messages.text.title}</td>
                  <td>{messages.text.credits}</td>
                </tr>
                <tr className={'top aligned'}>
                  <td>{messages.illustrations.title}</td>
                  <td>
                    <a href='https://www.stephaniestutz.ch'>Stephanie Stutz</a>
                  </td>
                </tr>
                <tr className={'top aligned'}>
                  <td>{messages.translation.title}</td>
                  <td>{messages.translation.credits}</td>
                </tr>
                <tr>
                  <td>{messages.publication.title}</td>
                  <td>
                    <TimestampFormatter
                      locale={locale}
                      timestamp={publicationDate}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className='column'>
            <FeedbackMessage className='' mailTo='24heures.web@sr.tamedia.ch' locale={locale} />

            <ShareButtons
              displayType={'vertical buttons'}
              className={'basic  blue'}
              articleId={articleId}
            />
          </div>
        </div>

        <div className='centered row copyright'>
          <div className='center aligned column'>
            <CopyrightNotice />
          </div>
        </div>
      </div>
    </VerticalSegment>
  )
}
